// removed by extract-text-webpack-plugin
module.exports = {"root":"marketingSection-module_root_1Y21N","block":"marketingSection-module_block_-Kb4I"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/marketingSection/marketingSection.module.css
// module id = 478
// module chunks = 1 3